import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const ArrowIcon = ({ color, className }: any) => {
  return (
    <SvgIcon style={styles.icon} className={className}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4 12H20M20 12L14 6M20 12L14 18"
          stroke={color || "currentColor"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default ArrowIcon;
